module.exports = __webpack_public_path__ + "img/storytelling.905695d0.webp";